import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const Minibanner = () => {
  const { currentCompany } = useSelector(state => state.init);
  const [isMobile, setIsMobile] = useState(false);
  const [imageError, setImageError] = useState({ mobile: false, desktop: false });

  // Detectar tamaño de pantalla
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Debug imágenes
  /*
  useEffect(() => {
    if (currentCompany?.verimageenviogratis) {
      console.log("=== DEBUG IMÁGENES ===");
      console.log("Desktop:", currentCompany.imageenviogratis);
      console.log("Mobile:", currentCompany.imageenviogratisMobile);
      console.log("Dispositivo actual:", isMobile ? "Mobile" : "Desktop");
    }
  }, [currentCompany, isMobile]);
*/
  if (!currentCompany || !currentCompany.verimageenviogratis) {
    return null;
  }

  // Determinar qué imagen mostrar
  let imageUrl = currentCompany.imageenviogratis;
  if (isMobile && currentCompany.imageenviogratisMobile && !imageError.mobile) {
    imageUrl = currentCompany.imageenviogratisMobile;
  }

  const handleImageError = type => {
    console.error(`Error cargando imagen ${type}:`, imageUrl);
    setImageError(prev => ({ ...prev, [type]: true }));
  };

  return (
    <div className="minibanner-container">
      <div className="flex justify-center items-start w-full p-0 m-0">
        <a href="/" title="Envío gratis por compras mayores a s/199" className="block w-full p-0 m-0">
          <img
            src={imageUrl}
            alt={`Envío gratis - ${currentCompany.name}`}
            className={`w-full max-h-[360px] ${isMobile ? "object-cover" : "object-contain"} block`}
            loading="eager"
            onError={() => handleImageError(isMobile ? "mobile" : "desktop")}
            onLoad={() => console.log("✅ Imagen cargada correctamente:", imageUrl)}
          />
        </a>
      </div>

      <style jsx>{`
        .minibanner-container {
          line-height: 0;
        }
      `}</style>
    </div>
  );
};

export default Minibanner;
